export default __webpack_public_path__ + "static/logo-abt-white-66f6ab7a3860f87644becb4b97bebbb8.png";